export function immutableAppend<T>(array: T[], elem: T): T[] {
  const result = array.slice(0)
  result.push(elem)
  return result
}
